import { useState } from 'react'

export const ModalType = {
  EDIT: 'EDIT',
  CREATE: 'CREATE',
  DELETE: 'DELETE',
  VIEW: 'VIEW',
  SEARCH: 'SEARCH'
}

const useModalForm = ({
  modelName,
  mutations = {},
  initialValues = {},
  enableSubmit = true,
  prepareVariables = null,
  beforeSubmit = null,
  afterSubmit = null,
  prepareForEdit = null,
  prepareForView = null,
  prepareForCreate = null,
  onError = null
}) => {
  const [formValues, setFormValues] = useState(initialValues)
  const [show, setShow] = useState(false)
  const [modalType, setModalType] = useState()
  const [mutation, setMutation] = useState()

  const showModal = () => setShow(true)
  const hideModal = () => {
    setShow(false)
    setModalType()
  }

  const handleCreate = () => {
    setModalType(ModalType.CREATE)
    const preparedValues = prepareForCreate ? prepareForCreate(initialValues) : initialValues
    setMutation(() => mutations.create)
    setFormValues(preparedValues)
    showModal()
  }

  const handleEdit = (values) => {
    setModalType(ModalType.EDIT)
    const preparedValues = prepareForEdit ? prepareForEdit(values) : values
    setMutation(() => mutations.update)
    setFormValues(preparedValues)
    showModal()
  }

  const handleView = (values) => {
    setModalType(ModalType.VIEW)
    setMutation(undefined)
    const preparedValues = prepareForView ? prepareForView(values) : values
    setFormValues(preparedValues)
    showModal()
  }


  const handleDelete = (values) => {
    setModalType(ModalType.DELETE)
    mutations.delete?.({ variables: values })
      .then(afterSubmit)
      .catch((error) => onError(error, 'delete'))
  }

  const onSubmit = async (values, formikBag) => {
    beforeSubmit?.()

    if (enableSubmit && mutation) {
      const variables = prepareVariables ? prepareVariables(values) : values
      await mutation({ variables }).then(() => {
        hideModal()
        afterSubmit?.()
      }).catch((error) => onError(error, formikBag, mutation === mutations.create ? 'create' : 'update'))
    }
  }

  return {
    isEdit: modalType === ModalType.EDIT,
    showModal,
    hideModal,
    handleCreate,
    handleView,
    handleEdit,
    handleDelete,
    modalProps: {
      modelName,
      modalType,
      show,
      initialValues: formValues,
      onClose: hideModal,
      onSubmit
    }
  }
}

export default useModalForm
